// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2i4xy","modalForm":"UpgradeEpcsModal_modalForm__18RuQ","modalFooter":"UpgradeEpcsModal_modalFooter__3yUQD"};